import styled from '@emotion/styled';

const DemoBadge = styled('span')({
  color: '#fff',
  backgroundColor: '#71318A',
  display: 'inline-block',
  padding: '.25em .4em',
  fontSize: '75%',
  fontWeight: 700,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  borderRadius: '.25rem',
});

export default DemoBadge;
